import { createStyles } from "@mantine/emotion";

export const useStylesContentBlocks = createStyles((theme) => ({
  white: {
    border: theme.customColors.tableBorder,
    backgroundColor: theme.customColors.white,
    padding: theme.spacing.contentBlocks.white.padding,
    position: "relative",
  },
}));
